import { ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { EnergyInterfacesStore } from '../stores/energy-interfaces.store';

export const energyInterfaceLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const energyInterfacesStore = inject(EnergyInterfacesStore);
  const energyInterfaceId = route.paramMap.get('energyInterfaceId');
  if (!energyInterfaceId) {
    return false;
  }

  if (energyInterfacesStore.energyInterfaces()?.some((ei) => ei.id === energyInterfaceId)) {
    return true;
  }
  // We explicitly do not await the loading here to allow the router to proceed immediately.
  // This enables the target component to handle and display its own loading and error states,
  // providing a better user experience (e.g., showing skeletons instead of a blank screen).
  energyInterfacesStore.loadItem(energyInterfaceId);
  return true;
};
